export const InstagramIcon = ({ className = "" }) => (
  <img
    src="/social-media-icons/instagram-icon.png"
    alt="Instagram"
    className={className}
  />
);

export const TikTokIcon = ({ className = "" }) => (
  <img
    src="/social-media-icons/tiktok-icon.png"
    alt="TikTok"
    className={className}
  />
);

export const SnapchatIcon = ({ className = "" }) => (
  <img
    src="/social-media-icons/snapchat-icon.png"
    alt="Snapchat"
    className={className}
  />
);

export const SocialIconsRow = ({ className = "" }) => (
  <span className={className} aria-hidden="true">
    <SnapchatIcon />
    <TikTokIcon />
    <InstagramIcon />
  </span>
);
